var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlugin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5835 5.75C10.5835 3.67893 12.2624 2 14.3335 2C16.4046 2 18.0835 3.67893 18.0835 5.75V8H19.5835C21.6802 8 22.7286 8 23.5556 8.34254C24.6582 8.79926 25.5342 9.6753 25.991 10.7779C26.3335 11.6049 26.3335 12.6533 26.3335 14.75H28.5835C30.6546 14.75 32.3335 16.4289 32.3335 18.5C32.3335 20.5711 30.6546 22.25 28.5835 22.25H26.3335V24.8C26.3335 27.3202 26.3335 28.5804 25.843 29.543C25.4116 30.3897 24.7232 31.0781 23.8765 31.5095C22.9139 32 21.6537 32 19.1335 32H18.0835V29.375C18.0835 27.511 16.5725 26 14.7085 26C12.8445 26 11.3335 27.511 11.3335 29.375V32H9.5335C7.01326 32 5.75314 32 4.79054 31.5095C3.94381 31.0781 3.2554 30.3897 2.82397 29.543C2.3335 28.5804 2.3335 27.3202 2.3335 24.8V22.25H4.5835C6.65456 22.25 8.3335 20.5711 8.3335 18.5C8.3335 16.4289 6.65456 14.75 4.5835 14.75H2.3335C2.3335 12.6533 2.3335 11.6049 2.67604 10.7779C3.13276 9.6753 4.00879 8.79926 5.11142 8.34254C5.93839 8 6.98676 8 9.0835 8H10.5835V5.75Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugin);
export default __webpack_public_path__ + "static/media/plugin.d469d9e9aed3f9399a42b23b535df18f.svg";
export { ForwardRef as ReactComponent };